/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query CBRRoutePlanReadQuery($routePlanId: ID) {
  CBRRoutePlanRead(routePlanId: $routePlanId) {
    id,
    createdAt,
    updatedAt,
    regex,
    status,
    Mcc {
      mcc,
      countryName
    },
    Mnc {
      id,
      mnc,
      network
    },
    CBRRoute {
      displayName
    }
    VendorAccount {
      id,
      displayName
    }
  }
}
`
